var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"header-search"},[_c('input',{attrs:{"type":"search","placeholder":_vm.$t('큐브룩검색_PLACEHOLDER').toString()}})])
}
var staticRenderFns = []

export { render, staticRenderFns }